export const normalizePositionTransferReason = reasons => {
    const reasonData = [...reasons];
    return [...reasonData].map(e => {
        return {
            ...e,
        };
    });
};
